import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";

interface TabDef {
  readonly to: string;
  readonly labelKey: string;
  readonly testId: string;
}

const TABS: readonly TabDef[] = [
  {
    to: "/compliance/documents",
    labelKey: "compliance.tabs.documents",
    testId: "compliance-tab-documents",
  },
  {
    to: "/compliance/requirements",
    labelKey: "compliance.tabs.requirements",
    testId: "compliance-tab-requirements",
  },
  {
    to: "/compliance/document-types",
    labelKey: "compliance.tabs.documentTypes",
    testId: "compliance-tab-document-types",
  },
  {
    to: "/compliance/locales",
    labelKey: "compliance.tabs.locales",
    testId: "compliance-tab-locales",
  },
];

export function ComplianceTabs() {
  const { t } = useTranslation();
  return (
    <nav
      aria-label={t("compliance.tabs.ariaLabel")}
      className="flex flex-wrap gap-1 border-b border-border"
    >
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end
          data-testid={tab.testId}
          className={({ isActive }) =>
            cn(
              "-mb-px border-b-2 px-3 py-2 text-sm font-medium",
              isActive
                ? "border-wander-orange text-wander-orange"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )
          }
        >
          {t(tab.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
}
